//Data
import styles from "./Member.module.css";

import FadeInSection from "../../components/FadeInSection";

const Member = ({member}) => {

  const {deltag, varMed, medlem, gave} = member
  const images = [deltag.image1Url, deltag.image2Url, varMed.image1Url, varMed.image2Url, medlem.image1Url, medlem.image2Url, gave.image1Url, gave.image2Url]

  return (
    
    <div className={styles.section2}>
      <FadeInSection >
        <div className={styles.headerWrapper}>
          <h1 className={styles.headline}>{member.header}</h1>
          <p dangerouslySetInnerHTML={{ __html: member.text }}/>
        </div>
      </FadeInSection>
      {/* ----- deltag ----- */}
      <FadeInSection >
        <div className={styles.memberRow1}>
            <div className={styles.discriptionWrapper1}>
              <h2 className={styles.memberCaption}>{deltag.header}</h2>
              <p dangerouslySetInnerHTML={{ __html: deltag.text }}/>
            </div>
          <div className={styles.actionWrapper1}>
            <div className={styles.bntWrapper}>
              <a
                href={deltag.img1Link}
                className={styles.memberBnt}
                style={{ backgroundImage: `url(${deltag.image1Url})`}}>
                <h3 className={styles.bntCaption}>{deltag.img1Text}</h3>
              </a>
              <a
                href={deltag.img2Link}
                className={styles.memberBnt}
                style={{ backgroundImage: `url(${deltag.image2Url})` }}>
                <h3 className={styles.bntCaption}>{deltag.img2Text}</h3>
              </a>
            </div>
          </div>
        </div>
        </FadeInSection>  
      {/* ----- Vær med -----*/}
      <FadeInSection >
        <div className={styles.memberRow2}>
          <div className={styles.actionWrapper2}>
            <div className={styles.bntWrapper}>
              <a
                href={varMed.img1Link}
                className={styles.memberBnt}
                style={{ backgroundImage: `url(${varMed.image1Url})` }}>
                <h3 className={styles.bntCaption}>{varMed.img1Text}</h3> 
              </a>
              <a
                href={varMed.img2Link}
                className={styles.memberBnt}
                style={{ backgroundImage: `url(${varMed.image2Url})` }}>
                <h3 className={styles.bntCaption}>{varMed.img2Text}</h3>
              </a>
            </div>
          </div>
          <div className={styles.discriptionWrapper2}>
            <h2 className={styles.memberCaption}>{varMed.header}</h2>
            <div dangerouslySetInnerHTML={{ __html: varMed.text }}/>
          </div>
        </div>
      </FadeInSection>
      {/* ---- bliv medlem ---- */}
      <FadeInSection >
        <div className={styles.memberRow1}>
            <div className={styles.discriptionWrapper1}>
              <h2 className={styles.memberCaption}>{medlem.header}</h2>
              <div dangerouslySetInnerHTML={{ __html: medlem.text }}/>
            </div>
          <div className={styles.actionWrapper1}>
            <div className={styles.bntWrapper}>
              <a
                href={medlem.img1Link}
                className={styles.memberBnt}
                style={{ backgroundImage: `url(${medlem.image1Url})`}}>
                <h3 className={styles.bntCaption}>{medlem.img1Text}</h3>
              </a>
              <a
                href={medlem.img2Link}
                className={styles.memberBnt}
                style={{ backgroundImage: `url(${medlem.image2Url})` }}>
                <h3 className={styles.bntCaption}>{medlem.img2Text}</h3>
              </a>
            </div>
          </div>
        </div>
      </FadeInSection>
      {/* ----- gave ------*/}
      <FadeInSection >
        <div className={styles.memberRow2}>
          <div className={styles.actionWrapper2}>
            <div className={styles.bntWrapper}>
              <a
                href={gave.img1Link}
                className={styles.memberBnt}
                style={{ backgroundImage: `url(${gave.image1Url})` }}>
                <h3 className={styles.bntCaption}>{gave.img1Text}</h3>
              </a>
              <a
                href={gave.img2Link}
                className={styles.memberBnt}
                style={{ backgroundImage: `url(${gave.image2Url})` }}>
                <h3 className={styles.bntCaption}>{gave.img2Text}</h3>
              </a>
            </div>
          </div>
          <div className={styles.discriptionWrapper2}>
            <h2 className={styles.memberCaption}>{gave.header}</h2>
            <div dangerouslySetInnerHTML={{ __html: gave.text }}/>
          </div>
        </div>
      </FadeInSection>
    </div>
    );
};

export default Member;
